export const trackHotjar = (log: string) => {
  // Hotjar event traking
  window['hj']('event', `[DEMO] ${log}`);
}